import {Component, OnDestroy, OnInit} from '@angular/core';
import {Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, ResolveStart, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {BreadcrumbsService} from './shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    navigating: boolean = false;

    private _routerSubscription: Subscription;

    constructor(
        private _router: Router,
        private _breadcrumbs: BreadcrumbsService
    ) {
    }

    ngOnDestroy() {
        this._routerSubscription && this._routerSubscription.unsubscribe();
    }

    ngOnInit() {
        this._routerSubscription = this._router.events.subscribe(
            (event: Event) => {
                if (event instanceof NavigationStart) {
                    this.navigating = true;
                    return;
                }
                if (
                    event instanceof NavigationCancel
                    || event instanceof NavigationError
                    || event instanceof ResolveStart
                    || event instanceof NavigationEnd
                ) {
                    this.navigating = false;
                }
                if (event instanceof NavigationEnd) {
                    this._breadcrumbs.reset();
                }
            }
        );
    }

    onOutletDeactivated(): void {
        let y = window.scrollY;
        let interval = setInterval(() => {
            if (y > 0) {
                y -= 50;
                window.scrollTo(0, y);
            } else {
                clearInterval(interval);
            }
        }, 10);
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/app.component.ts